import { render, staticRenderFns } from "./qx.vue?vue&type=template&id=083b758e&scoped=true&"
import script from "./qx.vue?vue&type=script&lang=js&"
export * from "./qx.vue?vue&type=script&lang=js&"
import style0 from "./qx.vue?vue&type=style&index=0&id=083b758e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b758e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083b758e')) {
      api.createRecord('083b758e', component.options)
    } else {
      api.reload('083b758e', component.options)
    }
    module.hot.accept("./qx.vue?vue&type=template&id=083b758e&scoped=true&", function () {
      api.rerender('083b758e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/cyzl/rightBar/base/qx.vue"
export default component.exports